"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEqual = void 0;
const is_equal_1 = require("./is-equal");
exports.isNotEqual = (a, b) => !is_equal_1.isEqual(a, b);
//# sourceMappingURL=is-not-equal.js.map